import React, { useState } from "react";

export default function Home() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className="min-h-screen bg-[#fefae0] flex flex-col">
            {/* Üst Navigasyon */}


            {/* Hero Bölümü */}
            <div className="flex-grow flex items-center justify-center px-6 py-12 md:py-24">
                <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
                    <div className="text-center md:text-left">
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#2f2f2f] mb-6 leading-tight">
                            Zarafetin <span className="border-b-4 border-amber-300">Doğal</span> Hali
                        </h1>
                        <p className="text-lg md:text-xl text-[#555] mb-8 max-w-lg">
                            Özenle seçilmiş gümüş takılarımızla kendinizi özel hissettirin. Yeni koleksiyonumuzla tarzınıza şıklık katın.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                            <a href="#" className="bg-[#2f2f2f] hover:bg-[#1a1a1a] text-[#fefae0] px-8 py-3 rounded-full font-medium transition duration-300">
                                Koleksiyonu Keşfet
                            </a>
                            <a href="#" className="border-2 border-[#2f2f2f] hover:bg-[#2f2f2f] hover:text-[#fefae0] px-8 py-3 rounded-full font-medium transition duration-300">
                                Hakkımızda
                            </a>
                        </div>
                    </div>
                    <div className="hidden md:block relative">
                        <div className="relative w-full h-96 bg-[#2f2f2f] rounded-lg overflow-hidden shadow-xl">
                            <div className="absolute inset-0 flex items-center justify-center text-[#fefae0]">
                                <span className="text-xl">Takı Fotoğrafı</span>
                            </div>
                        </div>
                        <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-amber-200 rounded-full opacity-30"></div>
                        <div className="absolute -top-6 -right-6 w-16 h-16 bg-amber-200 rounded-full opacity-30"></div>
                    </div>
                </div>
            </div>

            {/* Öne Çıkan Ürünler */}
            <div className="bg-[#2f2f2f] text-[#fefae0] py-16 px-6">
                <div className="max-w-6xl mx-auto">
                    <h2 className="text-3xl font-serif text-center mb-12">Öne Çıkan Ürünler</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {[1, 2, 3].map((item) => (
                            <div key={item} className="bg-[#3a3a3a] rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition duration-300">
                                <div className="h-64 bg-[#fefae0] flex items-center justify-center text-[#2f2f2f]">
                                    Ürün Fotoğrafı {item}
                                </div>
                                <div className="p-6">
                                    <h3 className="text-xl font-medium mb-2">Gümüş Kolye {item}</h3>
                                    <p className="text-amber-200 mb-4">₺{item === 1 ? '199' : item === 2 ? '249' : '179'}</p>
                                    <button className="w-full bg-amber-200 hover:bg-amber-300 text-[#2f2f2f] py-2 rounded transition duration-300">
                                        Sepete Ekle
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Footer */}

        </div>
    );
}